import * as React from 'react';

import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import CareerOutcomesModule from 'bundles/unified-description-page-common/components/modules/career-outcomes/CareerOutcomesModule';
import CareerSupport from 'bundles/unified-description-page-common/components/modules/career-outcomes/CareerSupport';
import DataBox from 'bundles/unified-description-page-common/components/modules/career-outcomes/DataBox';
import type { EnterpriseSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseSpecializationPageQuery';
import {
  getCareerOutcomesTitleForProfessionalCertificate,
  getCareerOutcomesValuePropsForProfessionalCertificate,
  getDefaultCareerResources,
} from 'bundles/unified-description-page-common/utils/careerOutcomes';
import { SPECIALIZATION_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import careerOutcomesDataBoxImage from 'images/unified-description-page/career-outcomes-professional-certificate.png';

type Props = {
  pageData: EnterpriseSpecializationPageFieldsFragment;
};

const EnterpriseCareerOutcomesModuleRenderer = ({ pageData }: Props) => {
  const domainName = pageData.domains?.[0]?.domainName;
  const features = useEnterpriseProductFeatures();

  return (
    <CareerOutcomesModule
      anchorId={SPECIALIZATION_NAV_ITEMS.OUTCOMES}
      title={getCareerOutcomesTitleForProfessionalCertificate(
        pageData.professionalCertificateType,
        domainName,
        pageData.careerOutcomes?.jobTitleForMedianEntryLevelSalary
      )}
      valueProps={getCareerOutcomesValuePropsForProfessionalCertificate({
        slug: pageData.slug,
        professionalCertificateType: pageData.professionalCertificateType,
        partnerName: pageData.partners?.[0]?.name,
        qualifyingJobTitles: pageData.careerOutcomes?.qualifyingJobTitles,
        additionalValueProps: pageData.careerOutcomes?.additionalValueProps,
      })}
      dataBox={
        <DataBox
          imageSrc={careerOutcomesDataBoxImage}
          careerGrowthInPercentage={pageData.careerOutcomes?.careerGrowthInPercentage}
          medianEntryLevelSalary={pageData.careerOutcomes?.medianEntryLevelSalary}
          jobTitleForMedianEntryLevelSalary={pageData.careerOutcomes?.jobTitleForMedianEntryLevelSalary}
          jobOpeningsInUs={pageData.careerOutcomes?.jobOpeningsInUs}
          domainName={domainName}
        />
      }
      careerSupport={
        features?.enableCareerSupport ? (
          <CareerSupport
            resources={pageData.careerOutcomes?.careerResources || getDefaultCareerResources()}
            hiringPartners={pageData.careerOutcomes?.hiringPartners}
          />
        ) : undefined
      }
    />
  );
};

export default EnterpriseCareerOutcomesModuleRenderer;
